import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17b7165a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "device-toast"
}

import device, { State } from '@/store/device';
import { computed, reactive, watch } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const data = computed<State>(() => store.state[device.name])
const state = reactive({
    visible: false,
    timer: 0
})
watch(() => data.value.toast, () => {
    if (data.value.toast) {
        clearTimeout(state.timer)
        state.visible = true
        //@ts-ignore
        state.timer = setTimeout(() => {
            state.visible = false
            data.value.toast = ''
        }, 3000);
    }
})

return (_ctx: any,_cache: any) => {
  return (_unref(state).visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(data).toast), 1))
    : _createCommentVNode("", true)
}
}

})